import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './ContactForm.css'; // Import custom CSS file
import axios from 'axios'; // Import axios

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    subject: false,
    message: false,
  });

  const [submitStatus, setSubmitStatus] = useState(""); // To handle submission status

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {
      name: formData.name === "",
      email: formData.email === "" || !/\S+@\S+\.\S+/.test(formData.email),
      subject: formData.subject === "",
      message: formData.message === "",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      axios.post('https://portfolio-server-91pj.onrender.com/contactUs', formData)
        .then((response) => {
          console.log("Form submitted successfully:", response.data);
          setSubmitStatus("Form submitted successfully!");
          // Reset form after successful submission
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
          setSubmitStatus("Error submitting form. Please try again.");
        });
    }
  };

  return (
    <div className="mystle">
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <h2 className="text-center mb-4">Contact Me</h2>
            <div className="card-shadow">
              <div className="card-body">
                <form onSubmit={handleSubmit} noValidate>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Full Name</label>
                    <input
                      type="text"
                      className={`form-control ${errors.name ? "is-invalid" : ""}`}
                      id="name"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                    {errors.name && (
                      <div className="invalid-feedback">Please enter your name.</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input
                      type="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      id="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                    {errors.email && (
                      <div className="invalid-feedback">Please enter a valid email address.</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="subject" className="form-label">Subject</label>
                    <input
                      type="text"
                      className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                      id="subject"
                      name="subject"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    />
                    {errors.subject && (
                      <div className="invalid-feedback">Please enter a subject.</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">Message</label>
                    <textarea
                      className={`form-control ${errors.message ? "is-invalid" : ""}`}
                      id="message"
                      name="message"
                      rows="5"
                      placeholder="Your Message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                    ></textarea>
                    {errors.message && (
                      <div className="invalid-feedback">Please enter a message.</div>
                    )}
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                  </div>
                </form>
                {/* Display submission status */}
                {submitStatus && (
                  <div className="mt-3 alert alert-info" role="alert">
                    {submitStatus}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
